import React, { useEffect, useMemo, useState } from "react";
import { StyledTablePage } from "../../styled-components/StyledTablePage.style";
import Flex from '@react-css/flex';
import Modal from 'react-modal';
import { StyledForm } from "../../styled-components/StyledForm.style";
import api from '../../services/api';

export const ModalTimesheetItemAtividadeHistorico = ({ atividade, isOpen, onAfterOpen, onRequestClose }) => {
  const [historicos, setHistoricos] = useState([]);

  const config = {
    headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Credentials': false
    }
  }

  const style = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        borderRadius: "0px",
        minWidth: '35%',
        overflowY: 'auto',
        minHeight: '45%',
        maxHeight: '90%',
        maxWidth: '100%'
    },
        overlay: {
            zIndex: 9999
        }
  };

  const colunas = useMemo(() => [{
    columns: [
      {
        Header: "Data do registro"
      },
      {
        Header: "Realizado por"
      },
      {
        Header: "Data de lançamento"
      },
      {
        Header: "Início"
      },
      {
        Header: "Término"
      },
      {
        Header: "Intervalo"
      },
      {
        Header: "Horas lançadas"
      },
      {
        Header: "Valor hora"
      },
      {
        Header: "Valor total"
      },
      {
        Header: "Status"
      }]
    }],
  []);

  useEffect(() => {
    const asyncFn = async () => {
      setHistoricos([])
      if(atividade?.idTimesheetItemAtividade && isOpen) {
        try {
          const response = await api.get(`Timesheet/atividade/${atividade?.idTimesheetItemAtividade}/historico`, config);
          setHistoricos(response.data.data);
        } catch (err) {}
      }
   }
    asyncFn()
  }, [atividade?.idTimesheetItemAtividade, isOpen])

  return (
    <Modal
        isOpen={isOpen}
        onAfterOpen={onAfterOpen}
        onRequestClose={onRequestClose}
        contentLabel="Histórico"
        style={style}
        ariaHideApp={false}
        shouldCloseOnOverlayClick={false}
    >
      <StyledForm>
        <p className="modal-close" onClick={onRequestClose}>X</p>
      </StyledForm>                       
      <Flex>
          <StyledForm style={{width: "100%"}}>
              <Flex>
                <Flex.Item className="modal-width">
                    <div className="position-relative form-group">                  
                      <p className="modal-title">Histórico das alterações</p>                                                        
                    </div>
                </Flex.Item>
              </Flex>                             
              <StyledTablePage>
                <div className="table-scroll">
                  <table className="table table-bordered table-width">
                    <thead>
                        <tr className="table-legend-info">
                          {colunas[0].columns.map(column => (
                              <th key={column.Header}>{column.Header}</th>
                          ))}
                        </tr>
                    </thead>
                    <tbody>
                      {historicos?.map((historico, index) => (
                        <tr key={historico.idTimesheetItemAtividadeLog} className={`${index == 0 ? 'primeiro-ativo' : ''}`}>
                          <td className="text-center">{historico.dataCriacao}</td>
                          <td className="text-center">{historico.nomeUsuario}</td>
                          <td className="text-center">{historico.datalancamento}</td>
                          <td className="text-center">{historico.periodoInicio}</td>
                          <td className="text-center">{historico.periodoFim}</td>
                          <td className="text-center">{historico.intervaloHoras}</td>
                          <td className="text-center">{historico.baseHoras}</td>
                          <td className="text-center">{historico.valorHoraBase}</td>
                          <td className="text-center">{historico.totalValorFaturado}</td>
                          <td className="text-center">{historico.status}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </StyledTablePage>
          </StyledForm>
      </Flex>
    </Modal>
  );
};